import mixpanel, { Dict } from 'mixpanel-browser';
import { APP_ENV } from '@/utils/environment';

const debug = ['local', 'stage', 'stage-2'].includes(APP_ENV);
const isAutomatedTest =
  typeof process !== 'undefined' && process.env.CYPRESS_AUTH_MOCKED === 'true';
const token = window.env.MIXPANEL_TOKEN;
const isEnabled = !!token;

if (isEnabled) {
  mixpanel.init(token, {
    debug,
    track_pageview: false,
  });
}

const analytics = {
  identify: (id: string, props: { email?: string; role?: string }): void => {
    if (isAutomatedTest || !isEnabled || !id) return;
    mixpanel.identify(id);
    mixpanel.people.set(props);
  },
  track: (eventName: string, props: Dict = {}): void => {
    if (isAutomatedTest || !isEnabled || !eventName) return;
    mixpanel.track(`IMW - ${eventName}`, props);
  },
};

export default analytics;
